<template lang="pug">
.custom-file-upload
  //- .d-flex.justify-content-center(
  //-   style='height: 96px;'
  //- )
    //- input.upa-file-input.compact.w-100(
    //-   type="file"
    //- )
  .bg-white.card.shadow.d-flex.flex-row.align-items-center(
    style='padding: 12px 16px;'
  )
    img.mr-2(src='@/assets/icons/upload-file-circle.svg' width='32px')

    .text-left
      template(v-if='file')
        .text-medium(style='color: #000')
          | {{ file.name }}

      a.cta.text-medium(
        href='#'
        @click='selectFile'
      )
        template(v-if='file') เลือกไฟล์ใหม่
        template(v-else) เลือกไฟล์

      template(v-if='file')
        a.cta.text-medium.ml-2(
          href='#'
          @click='file = null'
        )
          | นำออก

  input.hidden(
    type="file"
    :accept='accept'
    ref='file-input'
    @change='onFileSelected'
  )
</template>

<script>
export default {
  props: {
    value: {},
    accept: {
      default: '',
    },
  },
  data: () => ({
    file: null,
  }),

  watch: {
    // bind file & value
    value() { this.valueChanged(); },
    file() { this.fileChanged(); },

    // ...
  },

  mounted() {
    // bind file & value
    if (this.value) { this.valueChanged(); }
  },

  methods: {
    // bind file & value
    valueChanged() { this.file = this.value; },
    fileChanged() { this.$emit('input', this.file); },

    selectFile() {
      this.$refs['file-input'].click();
    },
    onFileSelected() {
      const selectedFile = this.$refs['file-input'].files[0];
      this.file = selectedFile;
    },
  },
};
</script>

<style lang="scss">
.custom-file-upload {
  input.hidden {
    display: none;
    // position: absolute;
    // left: 0;
    // top: 0;
    // opacity: 0;
  }

  .cta {
    text-decoration: underline;
    // color: $upa-blue;
  }
}
</style>
